module.exports = __webpack_public_path__ + "static/media/therappoint.efd632fc.png";